import React from "react";
import { LocalKeys, useTranslation } from "utilities/i18n";

/**
 * To avoid depending on hooks directly with an exchange, we use a simple component
 * for the error message.
 * @param error
 * @param i18nKey
 * @constructor
 */
const GraphqlErrorNotification: React.FC<{
  error: any;
  i18nKey?: LocalKeys;
}> = ({ error, i18nKey }) => {
  const { t } = useTranslation();
  return (
    <>{t(i18nKey || "ERROR_LOADING_DATA", { message: error.message || "" })}</>
  );
};

export default GraphqlErrorNotification;
